import { Feature } from '@/pinia/feature'

export const errands: Feature = {
  name: 'errands',
  enabled: true,
  access: ['FEAT_ERRAND_ADMIN', 'FEAT_ERRAND_CREATOR', 'FEAT_ERRAND_EDITOR', 'FEAT_ERRAND_READER'],
  title: {
    en: 'ToDo’s',
    sv: 'Ärenden'
  },
  component: 'FeatureCard',
  isRoute: true,
  props: {
    icon: 'IconCheckDone1',
    disableIsDrawPointActive: true,
    enableFullscreen: false,
    size: 'small',
    subtitle: {
      sv: 'Ärenden',
      en: 'ToDo’s'
    }
  },
  children: [
    {
      name: 'errands',
      enabled: true,
      title: {
        en: 'ToDo’s',
        sv: 'Ärenden'
      },
      children: [
        {
          name: 'errands-details',
          enabled: true,
          title: {
            en: 'ToDo’s',
            sv: 'Ärenden'
          },
          component: 'TicketsDashboard',
          isRoute: true,
          props: {
            icon: 'IconCheckDone1',
            disableIsDrawPointActive: true,
            fullscreen: false
          }
        }
      ]
    }
  ]
}
